define(() => {
    return ['JsonRPCService', (JsonRPCService) => {
        let dealerPromise;

        return {
            getDealersForBrand: getDealersForBrand,
        };

        function getDealersForBrand(callGroups, brandCode) {
            if (!dealerPromise) {
                dealerPromise = JsonRPCService.send('dealersearch', 'dealersearch', 'retrieve', [brandCode], callGroups, true);
            }
            return dealerPromise.then(dealers => dealers.sort((a, b) => a.name.localeCompare(b.name)));
        }
    }];
});


// WEBPACK FOOTER //
// ../common/js/src/edge/platform/basler/services/BaslerDealerSearchService.js